import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Chemdraw = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M35.003 14.898c0-.56.447-1.015 1-1.015.552 0 1 .455 1 1.015v14.204c0 .56-.448 1.015-1 1.015-.553 0-1-.454-1-1.015V14.898ZM7.995 13.883c-.552 0-1 .455-1 1.015v14.204c0 .56.448 1.015 1 1.015.553 0 1-.454 1-1.015V14.898c0-.56-.447-1.015-1-1.015Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.179 32.144c1.433.066 2.28-1.451 1.563-2.638-.482-.895-1.041-1.795-1.61-2.71-1.673-2.693-3.42-5.504-3.47-8.635v-2.248c.838 0 1.839-1.015 1.839-2.537S26 10.84 24.815 10.84h-5.667c-1.65 0-2.65 1.014-2.65 2.536s1 2.537 1.804 2.537v2.248c0 3.126-1.93 6.194-3.68 8.979-.497.791-.98 1.56-1.4 2.3-.652 1.187.195 2.704 1.497 2.704h14.46ZM19.584 22c.348-1.05.56-2.115.56-3.189v-4.906c-.098 0-.207.005-.32.01-.562.028-1.236.06-1.236-.517 0-.569.536-.545 1.148-.518.134.006.271.012.408.012h3.671c.136 0 .274-.006.409-.012.617-.027 1.17-.05 1.17.518 0 .576-.672.545-1.247.518a7.303 7.303 0 0 0-.332-.011v4.906c.014 1.048.227 2.122.57 3.19h-4.801Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.527 5.301 4.01 10.258a2.035 2.035 0 0 0-1.005 1.768l.037 9.98L3 31.986c-.003.73.38 1.405 1.005 1.768l8.511 4.95 8.467 5.019c.624.37 1.396.37 2.02 0l8.47-5.024 8.516-4.957a2.035 2.035 0 0 0 1.005-1.768l-.037-9.98.043-9.98a2.035 2.035 0 0 0-1.005-1.768l-8.511-4.95L23.017.276a1.976 1.976 0 0 0-2.02 0l-8.47 5.024Zm26.43 16.692.042-9.987-8.517-4.955-8.475-5.022-8.478 5.028-8.522 4.961.036 9.989-.042 9.987 8.517 4.955 8.475 5.022 8.478-5.028 8.522-4.961-.036-9.989Z"
  }));
});
Chemdraw.displayName = 'Chemdraw';
Chemdraw.defaultProps = {
  'aria-label': 'Chemdraw'
};
export default Chemdraw;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Chemdraw.js
// module id = 3750
// module chunks = 11